module.exports = __webpack_public_path__ + "img/ceo.28b89dec.jpg";